"use client"

/**
 * Re-validates the session on a back/forward cache restore (design §1.6).
 *
 * A bfcache snapshot replays without re-running React, so it can show stale
 * authenticated state; invalidating the ``me`` query lets ``AuthGate``
 * re-resolve to children or, via the global 401 handler, a redirect.
 */

import { useEffect } from "react"
import { useQueryClient } from "@tanstack/react-query"

import { currentUserKey } from "@/features/auth/hooks"

export function BfcacheRevalidator() {
  const queryClient = useQueryClient()

  useEffect(() => {
    function handlePageShow(event: PageTransitionEvent) {
      if (event.persisted) {
        queryClient.invalidateQueries({ queryKey: currentUserKey })
      }
    }
    window.addEventListener("pageshow", handlePageShow)
    return () => {
      window.removeEventListener("pageshow", handlePageShow)
    }
  }, [queryClient])

  return null
}
